import React, { useEffect } from "react";
import "vanilla-cookieconsent/dist/cookieconsent.css";
const CookieConsent = require("vanilla-cookieconsent");

export default function CookieConsentComponent() {
  useEffect(() => {
    const cookieconsent = CookieConsent.run({
      guiOptions: {
        consentModal: {
          layout: "cloud inline",
          position: "bottom center",
        },
      },

      categories: {
        necessary: {
          enabled: true, // this category is enabled by default
          readOnly: true, // this category cannot be disabled
        },
        analytics: {
          description:
            "These cookies help us understand how users interact with our website.",
        },
        advertising: {
          description: "These cookies are used to show relevant ads.",
        },
      },

      language: {
        default: "en",
        translations: {
          en: {
            consentModal: {
              title: "We value your privacy",
              description:
                "We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic. By clicking 'Accept all', you consent to our use of cookies.",
              acceptAllBtn: "Accept all",
              acceptNecessaryBtn: "Reject all",
              showPreferencesBtn: "Manage Individual preferences",
            },
            preferencesModal: {
              title: "Manage cookie preferences",
              acceptAllBtn: "Accept all",
              acceptNecessaryBtn: "Reject all",
              savePreferencesBtn: "Accept current selection",
              closeIconLabel: "Close modal",
              sections: [
                {
                  title: "Cookies? Sweet!",
                  description: "Manage your cookie preferences here.",
                },
                {
                  title: "Strictly Necessary Cookies",
                  description:
                    "These cookies are essential for the proper functioning of the website and cannot be disabled.",
                  linkedCategory: "necessary",
                },
                {
                  title: "Performance and Analytics",
                  description:
                    "These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.",
                  linkedCategory: "analytics",
                },
                {
                  title: "More information",
                  description:
                    'For any queries about our cookie policy and your choices, please <a href="https://cpidroid.com/contact">contact us</a>.',
                },
              ],
            },
          },
        },
      },
    });

    return () => {
      // Cleanup on unmount
      cookieconsent.destroy();
    };
  }, []);

  return null;
}
